import React from 'react';
import TooltipWrapper, {TooltipModifiers} from '../../../ui/components/common/TooltipWrapper';
import Button from '../../../incase-domain/components/button/Button';
import {randomString} from '../../../utils/utils';

interface SectionTitleProps {
    label: string;
    infoText?: string;
    warningText?: string;
    leading?: JSX.Element;
    className?: string;
}

export default function SectionTitle(props: SectionTitleProps): JSX.Element {
    const {label, infoText, warningText, leading, className} = props;

    return (
        <div className={`c-sidepanel__section_title ${className}`}>
            {label}
            <div style={{flex: '1'}} />
            {leading}
            {infoText && (
                <TooltipWrapper
                    className="c-sidepanel__section_infoTooltip"
                    id={randomString(10)}
                    content={infoText}
                    tooltipClassModifiers={TooltipModifiers.MULTILINE_TOOLTIP}
                >
                    <Button leading="ph:info" variant="ghost" size="sm" padded={false} />
                </TooltipWrapper>
            )}
            {warningText && (
                <TooltipWrapper
                    className="c-sidepanel__section_infoTooltip"
                    id={randomString(10)}
                    content={warningText}
                    tooltipClassModifiers={TooltipModifiers.MULTILINE_TOOLTIP}
                >
                    <Button leading="solar:danger-triangle-bold" variant="ghost" color="warning" size="sm" padded={false} />
                </TooltipWrapper>
            )}
        </div>
    );
}
